import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export let setScreenshotFileState = action('setScreenshotFileState')(
    function setScreenshotFileState(
        state: FeedbackViewState,
        imageBlob: Blob,
        imageFileBase64: string
    ) {
        state.screenshotBlob = imageBlob;
        state.screenshotFileBase64 = imageFileBase64;
    }
);

export let setScreenshotImageFromFileList = action('setScreenshotImageFromFileList')(
    function setScreenshotImageFromFileList(state: FeedbackViewState, files: FileList) {
        if (files == null) {
            state.screenshotBlob = null;
            state.screenshotFileBase64 = null;
        } else {
            for (let i = 0; i < files.length; i++) {
                let item: any = files[i];
                if (item.kind === 'file') {
                    let blob: Blob = item.getAsFile();
                    let reader: FileReader = new FileReader();
                    reader.onload = (e: any) => {
                        let imageBase64 = (e.target.result || '').trim();
                        setScreenshotFileState(state, blob, imageBase64);
                    };
                    reader.readAsDataURL(blob);

                    // We only support 1 file.
                    break;
                }
            }
        }
    }
);
